import {useGetCustomersV2Query} from '@dms/api/customer';

/**
 * Loads the customers that act as warehouse suppliers (institution SUPPLIER).
 *
 * Single source of the supplier query so every consumer shares one cache entry
 * and the institution filter is defined in one place (T20-136269).
 */
export const useGetSupplierCustomersQuery = () =>
  useGetCustomersV2Query({institutions: ['SUPPLIER']});
